import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const languages = [
    { code: 'en', country: 'US', name: 'English' },
    { code: 'ko', country: 'KR', name: '한국어' },
    { code: 'ja', country: 'JP', name: '日本語' },
    { code: 'zh', country: 'CN', name: '中文' }
  ];
  
  // Find current language display info
  const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];
  
  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    document.documentElement.lang = langCode;
    setIsOpen(false);
  };
  
  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  return (
    <div className="language-switcher" ref={dropdownRef} role="navigation" aria-label="Language Selector">
      <button 
        className="language-switcher-button" 
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <ReactCountryFlag
          countryCode={currentLang.country}
          svg
          style={{
            width: '1.2em',
            height: '1.2em',
          }}
          title={currentLang.name}
          aria-hidden="true"
        />
        <span className="language-name">{currentLang.name}</span>
        <span className="dropdown-arrow">▼</span>
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={i18n.language === lang.code ? 'active' : ''}
              aria-label={`Switch to ${lang.name}`}
            >
              <ReactCountryFlag
                countryCode={lang.country}
                svg
                style={{
                  width: '1.2em',
                  height: '1.2em',
                }}
                title={lang.name}
                aria-hidden="true"
              />
              <span className="language-name">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;